export const disabledBubblesSupportArticle =
  'https://support.code.org/hc/en-us/articles/360020520891';
